export default function capitalizeFirstLetter(str) {
  // Make the first letter uppercase and the rest lowercase
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}